function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 13l5.646 5.646a.5.5 0 00.708 0L22 13",
  stroke: "#8390AB",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var SvgIconNaviArrowDown = function SvgIconNaviArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgMEwwLjM1MzU1MyA1LjY0NjQ1QzAuMTU4MjkxIDUuODQxNzEgMC4xNTgyOTEgNi4xNTgyOSAwLjM1MzU1MyA2LjM1MzU1TDYgMTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwIDE5KSByb3RhdGUoLTkwKSIgc3Ryb2tlPSIjODM5MEFCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgIconNaviArrowDown as ReactComponent };